export default "__VITE_ASSET__2e18dcf7__"